import styled from 'styled-components';
import FlexBox from '../../../components/ui/flexbox/FlexBox';

const Text = styled.div`
	font-size: 25px;
	font-weight: 600;
	margin-top: 10px;
`;

const UnavailablePodcast = () => {
	return (
		<FlexBox $direction="column" $alignItems="center">
			<Text>This podcast is currently unavailable.</Text>
		</FlexBox>
	);
};

export default UnavailablePodcast;
// File renamed to src/features/documents/components/UnavailablePodcast.tsx
